<h4>ADMIN UPLOADER</h4>
<p>Remember this page is for admins only. Customers will not be able to see this.</p>
<!-- TODO: Use fileDrop: Like in keyword-form.component.ts -->
<input [style.display]="'none'" id="keywordUploader" type="file" accept="text/csv"
  (change)="parseImports($event.target)" />
<button class="btn btn-default btn-sm ml-2" (click)="openFileSelector('keywordUploader')">Choose file</button>
<button class="btn btn-default btn-sm ml-2" (click)="clearFile()" *ngIf="showImportRows">Clear</button>
<div *ngIf="showImportRows" class="mt-2">
  <div *ngIf="headerErrors.length > 0" class="alert-danger p-2 mb-3">Header Error: {{headerErrors.join(', ')}}</div>
  <div *ngIf="bodyErrors.length > 0" class="alert-danger p-2 mb-3">
    Data Errors:
    <ol>
      <li *ngFor="let error of bodyErrors">{{error}}</li>
    </ol>
  </div>
  <div *ngIf="bodyRows?.length > 0" class="overflow-auto">
    <p *ngIf="headerErrors.length > 0">You are trying to import {{bodyRows.length}} requests.</p>
    <p *ngIf="uploadErrors?.length > 0">Due to 1 or more errors, no requests were uploaded or activated.</p>
    <table class="table table-striped table-hover">
      <tr>
        <th></th>
        <th *ngIf="parsedUploadErrors.keyword.length > 0">General errors</th>
        <th *ngFor="let header of headerRow" [class.table-danger]="headerHasError(header, ALLOWED_FIELDS)">
          {{header}}
        </th>
      </tr>
      <tr *ngFor="let row of bodyRows; let rowIndex = index;">
        <td>{{rowIndex + 1}}</td>
        <td *ngIf="parsedUploadErrors.keyword.length > 0">
          {{uploadError('keyword', rowIndex)}}
        </td>
        <td *ngFor="let data of row; let columnIndex = index;" class="truncated"
          [class.table-danger]="cellError(data, columnIndex, rowIndex)">
          {{data}} <span *ngIf="cellError(data, columnIndex, rowIndex)"><small>-
              {{cellError(data, columnIndex, rowIndex) }}</small></span>
        </td>
      </tr>
    </table>
  </div>
  <div class="mt-3 d-flex flex-row justify-content-end">
    <button class="btn btn-primary ml-2" [disabled]="disableImportButton()"
      (click)="onSubmit()">
      {{submitting ? 'Importing Requests...' : 'Import'}}
    </button>
  </div>
  <div *ngIf="resultsReady">

    <div *ngIf="uploadErrors.length === 0; else errorSection">
      <h5>Results</h5>
      <p>{{uploadedKeywords.length}} requests were activated successfully:</p>
      <ul>
        <li *ngFor="let k of uploadedKeywords">
          <a [routerLink]="['../../../', k.customer.id, 'topics', k.id, 'edit']">{{k.phrase}}</a>  for customer: <strong>{{k.customer.businessName}}</strong>
        </li>
      </ul>
    </div>
    <ng-template #errorSection>
      <h5>Error Summary</h5>
      <div class="alert-danger p-2 mb-3">
        <ul>
          <li *ngFor="let error of parsedUploadErrors.writer">Writer {{error.id}}: {{error.error}}</li>
          <li *ngFor="let error of parsedUploadErrors.customer">Subscription {{error.id}}: {{error.error}}</li>
          <li *ngFor="let error of parsedUploadErrors.keyword">Request row {{error.id + 1}}: {{error.error}}</li>
        </ul>
      </div>
    </ng-template>
  </div>
</div>